import { useSyncExternalStore } from "react";

const subscribe = (onChange: () => void) => {
  window.addEventListener("resize", onChange);

  return () => window.removeEventListener("resize", onChange);
};

/** Viewport height, re-rendering on resize. */
export const useWindowHeight = (): number =>
  useSyncExternalStore(
    subscribe,
    () => window.innerHeight,
    () => 0 // No viewport when server-rendered.
  );
